import { useRouter } from 'next/router';
import React from 'react';

import { AdminHomeTableSection } from '../../../../utils/interfaces';

interface CardProps {
  title: string;
  count: number;
}

const AdminHomeCard: React.FC<CardProps> = ({ title, count }) => {
  return (
    <div className='flex justify-center items-center p-4 bg-white shadow-md h-28 w-28 border rounded-md'>
      <div className='flex flex-col text-center text-sm gap-y-3'>
        <span className='flex justify-center'>
          <span className='w-2/3 text-xs font-medium text-center flex justify-center'>
            {title}
          </span>
        </span>
        <span className='font-medium text-primary text-lg'>{count}</span>
      </div>
    </div>
  );
};

interface Props {
  data: AdminHomeTableSection[];
}

const AdminHomeTable: React.FC<Props> = ({ data }) => {
  const router = useRouter();
  return (
    <div className='flex flex-col  w-full'>
      <div className='border-b border-gray-800' />
      {data?.map((section, index) => (
        <div
          key={index}
          onClick={() => section?.route && router.push(`${section?.route}`)}
          className='flex justify-between border-b p-7 cursor-pointer hover:bg-gray-50 border-gray-800'
        >
          <div className='flex flex-col w-2/6'>
            <span className='text-2xl font-medium'>{section.title}</span>
            <span className='text-sm'>{section.desc}</span>
          </div>
          <div className='flex gap-x-4'>
            {section.card.map((card, cardIndex) => (
              <AdminHomeCard key={cardIndex} {...card} />
            ))}
          </div>
        </div>
      ))}
    </div>
  );
};

export default AdminHomeTable;
